import useAppSelector from '../../../store/hooks/useAppSelector'
import { CartHiddenRoutes } from '../../app/constants'
import useRouteMatch from '../../app/hooks/useRouteMatch'
import { isPreOrderCheckoutSelector } from '../../preOrder/store/preOrderSelectors'
import { currentCheckoutCartRailItemQtySelector } from '../store/checkoutSelectors'

import useCartDrawerOpen from './useCartDrawerOpen'

/**
 * The closed cart shows as a rail (large desktops) or a bottom bar
 * while there is something in it. It replaces the navbar cart button, so it
 * is the way back to a closed cart on every page that has one.
 */
export default function useCartRailVisible() {
  const isCartRailHiddenRoute = useRouteMatch(CartHiddenRoutes)

  const isCartDrawerOpen = useCartDrawerOpen()
  const itemCount = useAppSelector(currentCheckoutCartRailItemQtySelector)
  const isPreOrderCheckout = useAppSelector(isPreOrderCheckoutSelector)

  return (
    !isCartRailHiddenRoute &&
    (isPreOrderCheckout || itemCount > 0) &&
    !isCartDrawerOpen
  )
}
